import { Chip } from "@mui/material";
import React ,{memo}from "react";
import GaugeChart from "react-gauge-chart";

const chipStyle = {
  color: "#d3f4fe",
  minWidth: '50px',       
};

const OutdoorTemperatureKPI = memo(({avgTemp,maxTemp,minTemp}) => {
  return (
    <>
      <GaugeChart
        id="gauge-chart4"
        animate={false}
        arcsLength={[0.2, 0.2, 0.4, 0.2, 0.2]}
        colors={["blue", "DeepSkyBlue", "lawngreen", "#ffff00", "#f00"]}
        arcPadding={0.1}
        cornerRadius={4}
        percent={avgTemp / 48}
        hideText={true}
        style={{ width: "110px" }}
        className="dashboard-health-title"
      />
      <span>{avgTemp}°C</span>
      <p className="card-value">Temperature</p>
      <div className="d-flex flex-column justify-content-start align-items-start gap-2">
        <div className="d-flex justify-content-center align-items-center card-value">
          <Chip label="Max"  sx={chipStyle} />
          <p className="m-1 p-0">{maxTemp}</p>
        </div>
        <div className="d-flex justify-content-center card-value">
          <Chip label="Min"  sx={chipStyle}  />
          <p className="m-1 p-0">{minTemp}</p>
        </div>
      </div>
     
    </>
  );
});

export default OutdoorTemperatureKPI;
